const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    width: "8.2250137mm",
    height: "8.2250156mm",
    viewBox: "0 0 8.2250137 8.2250156",
    id: "svg5116",
    "inkscape:version": "0.92.3 (2405546, 2018-03-11)",
    "sodipodi:docname": "settings_icon.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs5110"
  }), /*#__PURE__*/React.createElement("sodipodi:namedview", {
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    "inkscape:pageopacity": 0,
    "inkscape:pageshadow": 2,
    "inkscape:zoom": 0.35,
    "inkscape:cx": 15.543334,
    "inkscape:cy": 15.543325,
    "inkscape:document-units": "mm",
    "inkscape:current-layer": "layer1",
    showgrid: "false",
    "inkscape:window-width": 2880,
    "inkscape:window-height": 1674,
    "inkscape:window-x": 0,
    "inkscape:window-y": 60,
    "inkscape:window-maximized": 1
  }), /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5113"
  }, /*#__PURE__*/React.createElement("rdf:RDF", null, /*#__PURE__*/React.createElement("cc:Work", {
    "rdf:about": ""
  }, /*#__PURE__*/React.createElement("dc:format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dc:type", {
    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dc:title", null)))), /*#__PURE__*/React.createElement("g", {
    "inkscape:label": "Layer 1",
    "inkscape:groupmode": "layer",
    id: "layer1",
    transform: "translate(85.377388,-144.72082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -78.599998,147.2349 0.347486,-0.99096 -0.433564,-0.43356 -0.98178,0.35701 c -0.105833,-0.0674 -0.236714,-0.14005 -0.391936,-0.20567 -0.162278,-0.0681 -0.312208,-0.11183 -0.438856,-0.1404 -0.155927,-0.31644 -0.311502,-0.63253 -0.46743,-0.94898 H -81.5785 l -0.452262,0.94898 c -0.1143,0.0131 -0.273402,0.0437 -0.449438,0.11818 -0.16757,0.0713 -0.294923,0.15875 -0.382764,0.22895 -0.330553,-0.11571 -0.661106,-0.23142 -0.991306,-0.34713 l -0.433211,0.43321 0.356658,0.98178 c -0.07373,0.1016 -0.160866,0.242 -0.233186,0.42086 -0.07056,0.17427 -0.10548,0.33161 -0.123472,0.45438 -0.312561,0.14076 -0.625475,0.28222 -0.938389,0.42298 v 0.61278 l 0.938389,0.43779 c 0.0187,0.11818 0.05397,0.26953 0.123472,0.43639 0.07267,0.17533 0.160161,0.31256 0.234245,0.41134 -0.115711,0.32985 -0.231422,0.66005 -0.346781,0.98989 l 0.433211,0.43321 0.981075,-0.3563 c 0.08749,0.0663 0.203906,0.14111 0.348897,0.20602 0.190853,0.085 0.36442,0.12241 0.493184,0.1397 0.1524,0.31609 0.304447,0.63253 0.456847,0.94897 h 0.612422 l 0.438503,-0.93839 c 0.139347,-0.0286 0.310797,-0.0772 0.497417,-0.16157 0.137583,-0.0624 0.254,-0.13123 0.349602,-0.19614 0.3302,0.11571 0.6604,0.23177 0.9906,0.34713 l 0.432859,-0.43321 -0.356659,-0.98143 c 0.06244,-0.0892 0.12947,-0.19967 0.189442,-0.3309 0.08855,-0.19403 0.134761,-0.37218 0.160161,-0.51294 0.315031,-0.15134 0.630414,-0.30304 0.945092,-0.45473 v -0.61278 l -0.94862,-0.45332 c -0.02399,-0.12347 -0.06385,-0.27552 -0.134408,-0.44238 -0.06703,-0.15875 -0.143933,-0.28857 -0.213078,-0.38876 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.30303609,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1332",
    "inkscape:connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -79.040264,148.83333 c 0,-1.22872 -0.995892,-2.22461 -2.224264,-2.22461 -1.229078,0 -2.22497,0.99589 -2.22497,2.22461 0,1.22873 0.995892,2.22462 2.22497,2.22462 1.228372,0 2.224264,-0.99589 2.224264,-2.22462 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 0.30303609,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1334",
    "inkscape:connector-curvature": 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings_icon.1a7f72910a50c77328c1f95d31ac544c.svg";
export { ForwardRef as ReactComponent };